export const selectIsPremium = ({details}) => details.isPremium;
export const selectHideUpsell = ({details}) => details.hideUpsell;
export const selectDowngraded = ({details}) => details.downgraded;
export const selectEnvelopes = ({fabricTemplate}) => fabricTemplate.allEnvelopes;
export const selectQuickInvite = ({fabricTemplate}) => fabricTemplate.quickInvite;
export const selectLiners = ({fabricTemplate}) => fabricTemplate.allLiners;
export const selectBackgrounds = ({fabricTemplate}) => fabricTemplate.allBackgrounds;
export const selectOverlays = ({fabricTemplate}) => fabricTemplate?.allOverlays;
export const selectReveals = ({fabricTemplate}) => fabricTemplate?.allReveals;
export const selectStamps = ({fabricTemplate}) => fabricTemplate.allStamps;
export const selectStickers = ({fabricTemplate}) => fabricTemplate.allStickers;
export const selectSnapshot = ({fabricTemplate}) => fabricTemplate.snapshot;
export const selectIsPremiumTemplate = ({fabricTemplate}) => fabricTemplate?.premium;
export const selectEventType = ({fabricTemplate}) => fabricTemplate.eventType;
export const selectRsvpOptional = ({fabricTemplate}) => fabricTemplate.rsvpOptional;
export const selectUsedAs = ({fabricTemplate}) => fabricTemplate.usedAs;
